module.exports = __webpack_public_path__ + "img/logoArty-2.e3e2ab31.png";